const billeteras = {
    "com.yacare.test": 'Yacaré',
    "ar.com.santander": 'Santander Río',
    "com.mercadolibre": 'Mercado Pago',
    "ar.com.bna": 'BNA+',
    "com.columbia": "Columbia",
    "ar.com.cuentadni": "Cuenta DNI",
    "app.ank": "Ank",
    "ar.com.reba": "Reba",
    "ar.com.modo": "MODO",
    "ar.com.claro": "Claro",
    "ar.com.moni": "Moni",
    'app.miiii': "Miiii",
    'ar.com.epagos': "E Pagos",
    'ar.com.uala': "Ualá",
    'com.resimple': "Re Simple",
    'ar.com.valepei': "Vale Pei",
    'com.pluspagos': "Plus Pagos",
    'com.auntap': "Tap",
    'ar.com.personalpay': "Personal Pay"
}

const pspDemo = {
    '0300': "AgilPagos",
    '0009': "Mercado Pago",
    '0406': "E Pagos",
    '0028': "Ualá",
    '0070': "Re Simple",
    '0170': "Tap",
    '0314': "Personal Pay",
    '0247': "Claro",
    '0254': "Plus Pagos"
}

const pspProd = {
    "0003": "Mercado Pago",
    "0010": "Miiii",
    "0029": "Nubi",
    "0034": "Re Simple",
    "0040": "Tap",
    "0072": "MONI",
    "0091": "Taca Taca",
    "0119": "viüMi",
    "0130": "E Pagos",
    "0148": "Openpay",
    "0007": "Ualá"
}

export { billeteras, pspDemo, pspProd }